module.exports = __webpack_public_path__ + "media/images/official/about_yamori_mochimune_b-9d383d115ef707eb9f7437c62fe6fb62.png";